var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14645 4.81344C2.34171 4.61818 2.65829 4.61818 2.85355 4.81344L7.83333 9.79322L12.8131 4.81344C13.0084 4.61818 13.325 4.61818 13.5202 4.81344C13.7155 5.0087 13.7155 5.32528 13.5202 5.52055L8.18689 10.8539C7.99162 11.0491 7.67504 11.0491 7.47978 10.8539L2.14645 5.52055C1.95118 5.32528 1.95118 5.0087 2.14645 4.81344Z",
    fill: "#FE4747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.ae76611c743d9025e2b1e16887894a06.svg";
export { ForwardRef as ReactComponent };